import React from "react";

export default function SoMe() {
  return (
    <div className="contact__content__social">
      <a className="contact__content__social--title" href="#header">alexandraep</a>
      <div className="contact__content__social__icons">
        <ul>
          <li>
            <a href="mailto:bahalexa@hotmail.com">
              <i className="ri-mail-fill"></i>
            </a>
          </li>
          <li>
            <a href="https://instagram.com/alexandraep">
              <i className="ri-instagram-fill"></i>
            </a>
          </li>
          <li>
            <a href="https://github.com/frontalexandraep">
              <i className="ri-github-fill"></i>
            </a>
          </li>
          <li>
            <a href="https://www.linkedin.com/in/alexandra-pettersen-4a1753191/">
              <i className="ri-linkedin-box-fill"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
